import React from "react";
  function LogoIsNew(){
      return (
        <div className="is-new">
          <span>NEW</span>
        </div>
      )
  }

  export default LogoIsNew